import React from 'react'
import { css } from 'glamor'
import { propMerge } from 'glamor/react'
import { colours } from '../../constants/colourConstants'
import { mediaQueries } from '../../constants/mediaQueries'

const styles = css({
	color: colours.greys.blue,
	fontSize: "14px",
	[mediaQueries.isMobile]: {
		fontSize: '14px',
	},
})

const Paragraph = ({ children, ...otherProps }) => {
	return <p {...propMerge(styles, otherProps)}>{children}</p>
}

export default Paragraph
